import acordeon from "../lib/aria/acordeon";
var preguntasFrecuentes = function () {
    acordeon('.preguntas_frecuentes__grupo__preguntas', false);
};
export default preguntasFrecuentes;
